// Shared live instances let the treasure encounter coordinate all three guardians.
import Vue from 'vue'
export const knights = new Set()
export const equipment = Vue.observable({ shields: [] })
